/**
 * Normalize API response or state to a string trial/id.
 * Handles string, number, or object with .id, .trial_id, .result, or .data.id.
 * Use this so we never pass [object Object] into API query params.
 */
export function normalizeTrialId(value) {
  if (value == null) return undefined;
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    if (value.id != null) return String(value.id);
    if (value.trial_id != null) return String(value.trial_id);
    if (value.calibration_id != null) return String(value.calibration_id);
    if (value.result != null) return String(value.result);
    if (value.data != null && typeof value.data === 'object' && value.data.id != null) return String(value.data.id);
    if (typeof value.data === 'string' || typeof value.data === 'number') return String(value.data);
  }
  return undefined;
}
